<template>
  <div class="activation-container">
    <el-button
      class="mwow-button-filled primary export-button"
      @click="handleExport"
      v-debounce="5000"
    >
      导出
    </el-button>
    <div
      class="mwow-form"
      style="margin-bottom: 24px; display: flex; align-items: center"
    >
      <el-radio-group
        v-model="chartVisible"
        @change="
          (v) => {
            if (v === 1) {
              myChart.resize();
            }
          }
        "
      >
        <el-radio-button :label="1">可视化</el-radio-button>
        <el-radio-button :label="2">数据明细</el-radio-button>
      </el-radio-group>
      <el-radio-group
        v-model="chartStep"
        @change="chartRender"
        v-show="chartVisible === 1"
        style="margin-left: 24px"
        class="date-range-type-radio"
      >
        <el-radio-button :label="1" v-if="dateRangeType > 2"
          >月</el-radio-button
        >
        <el-radio-button :label="2" v-if="dateRangeType > 1"
          >周</el-radio-button
        >
        <el-radio-button :label="3" v-if="dateRangeType < 3"
          >日</el-radio-button
        >
      </el-radio-group>
      <el-popover
        placement="top"
        trigger="hover"
        popper-class="followuppopover"
      >
        <p>
          耗课活跃度=全部在读学员的耗课活跃度之和<br />
          续费活跃度=全部在读学员的续费活跃度之和<br />
          作业活跃度=全部在读学员的作业活跃度之和<br />
          APP使用活跃度=全部在读学员的APP使用活跃度之和<br />
          学员综合活跃度=耗课活跃度+续费活跃度+作业活跃度+APP使用活跃度
        </p>
        <i
          slot="reference"
          class="el-icon-question"
          style="
            margin-left: 8px;
            color: #bebfc0;
            font-size: 16px;
            vertical-align: text-bottom;
          "
        ></i>
      </el-popover>
      <p class="showing-data">
        <span style="margin-right: 16px">{{ topShowingValue[0] }}</span>
        <span>{{ topShowingValue[1] }}</span>
      </p>
      <div style="flex: 1"></div>
      <div class="filter-button" @click="showFilterDialog">
        <img
          src="https://wowsite.musicwow.com/background_manage_frontend/images/store/filter.png"
          width="30"
          class="icon"
        />
        <div>
          <p>统计筛选</p>
          <p class="small">
            (已选{{ activeColumn.length + "/" + columnFilter.length }})
          </p>
        </div>
      </div>
    </div>
    <div id="activation-echart-wrap" v-show="chartVisible === 1"></div>
    <div v-show="chartVisible === 2">
      <common-search-form-wrapper :reset="resetSearch" :hiddenExpand="true">
        <el-form size="mini" :model="searchInfo" label-width="80px">
          <el-row>
            <el-col :span="8">
              <el-form-item label="学员名称：" prop="student_id">
                <el-select
                  v-model.number="searchInfo.student_id"
                  filterable
                  clearable
                  placeholder="请选择学员"
                  :filter-method="handleSearchStudent"
                  @change="
                    () => {
                      handleSearch();
                      handleSearchStudent('');
                    }
                  "
                >
                  <el-option
                    v-for="item in searchStudentList"
                    :key="item.student_id"
                    :label="item.name"
                    :value="item.student_id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="首次入学时间：" prop="transform_date">
                <el-date-picker
                  v-model="searchInfo.transform_date"
                  type="daterange"
                  range-separator="至"
                  value-format="yyyy-MM-dd"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  @change="handleSearch"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="已耗课次数：" prop="roll_call_consume_count">
                <div class="input-range-wrap">
                  <el-input
                    v-model="searchInfo.roll_call_consume_count_1"
                    type="number"
                    placeholder="最低次数"
                    @change="
                      (v) => {
                        let res = '';
                        if (v !== '') {
                          res = Number(v);
                          if (
                            searchInfo.roll_call_consume_count_2 !== '' &&
                            res > Number(searchInfo.roll_call_consume_count_2)
                          ) {
                            $message({
                              type: 'warning',
                              message: '最低次数不可高于最高次数',
                            });
                            res = '';
                          }
                          if (res < 0) {
                            $message({
                              type: 'warning',
                              message: '最低次数不可小于0',
                            });
                            res = '';
                          }
                          if (res > 99999) {
                            $message({
                              type: 'warning',
                              message: '最低次数数值过大',
                            });
                            res = '';
                          }
                        }
                        searchInfo.roll_call_consume_count_1 =
                          res !== '' ? Math.floor(res) : '';
                        handleSearch();
                      }
                    "
                  ></el-input>
                  <span>至</span>
                  <el-input
                    v-model="searchInfo.roll_call_consume_count_2"
                    type="number"
                    placeholder="最高次数"
                    @change="
                      (v) => {
                        let res = '';
                        if (v !== '') {
                          res = Number(v);
                          if (
                            searchInfo.roll_call_consume_count_1 !== '' &&
                            res < Number(searchInfo.roll_call_consume_count_1)
                          ) {
                            $message({
                              type: 'warning',
                              message: '最高次数不可低于最高次数',
                            });
                            res = '';
                          }
                          if (res < 0) {
                            $message({
                              type: 'warning',
                              message: '最高次数不可小于0',
                            });
                            res = '';
                          }
                          if (res > 99999) {
                            $message({
                              type: 'warning',
                              message: '最高次数数值过大',
                            });
                            res = '';
                          }
                        }
                        searchInfo.roll_call_consume_count_2 =
                          res !== '' ? Math.floor(res) : '';
                        handleSearch();
                      }
                    "
                  >
                  </el-input>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="16">
              <el-form-item label="学员状态:">
                <el-radio-group
                  v-model="searchInfo.student_status"
                  size="mini"
                  @change="handleSearch"
                >
                  <el-radio-button label="all">全部</el-radio-button>
                  <el-radio-button label="on_going">在读</el-radio-button>
                  <el-radio-button label="history">历史</el-radio-button>
                  <el-radio-button label="delete">删除</el-radio-button>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </common-search-form-wrapper>
      <el-table
        class="mwow-table"
        size="mini"
        v-horizontal-scroll
        :data="showingData"
        stripe
        style="width: 100%"
        tooltip-effect="dark"
        ref="main-table"
        @sort-change="clickStort"
      >
        <el-table-column
          label="序号"
          type="index"
          fixed="left"
        ></el-table-column>
        <el-table-column
          v-for="item in activeColumn"
          :key="item.key"
          :prop="item.key"
          :label="item.label"
          :min-width="item.label.length * 17 + 45"
          :sortable="item.sort ? 'custom' : false"
          :sort-orders="item.sort ? ['ascending', 'descending'] : []"
          :fixed="item.fixed ? 'left' : false"
        >
          <template slot="header" v-if="item.tips">
            <span>{{ item.label }}</span>
            <el-popover
              placement="top"
              trigger="hover"
              popper-class="followuppopover"
            >
              <p
                v-html="item.tips"
                style="max-width: 420px; min-width: 180px"
              ></p>
              <i
                slot="reference"
                class="el-icon-question"
                style="
                  margin-left: 8px;
                  color: #bebfc0;
                  font-size: 16px;
                  vertical-align: text-bottom;
                "
              ></i>
            </el-popover>
          </template>
          <template slot-scope="scope">
            <div v-if="item.key === 'student_name'">
              <div class="mwow-gray" v-if="scope.row.is_del === 1">
                {{ scope.row.name || "-"
                }}<span class="mwow-tag del-filled large">已删除</span>
              </div>
              <div
                v-else
                class="mwow-green"
                style="cursor: pointer"
                @click="toStudentDetail(scope.row)"
              >
                {{ scope.row.student_name || "-" }}
              </div>
            </div>
            <div v-else>{{ scope.row[item.key] || "-" }}</div>
          </template>
        </el-table-column>
      </el-table>
      <div style="overflow: hidden">
        <el-pagination
          :current-page="page"
          :page-size="pageSize"
          :page-sizes="pageSizeArray"
          :pager-count="5"
          :style="{ float: 'right', padding: '20px' }"
          :total="total"
          @current-change="handlePagerChange"
          @size-change="handlePagerSizeChange"
          layout="total, sizes, prev, pager, next, jumper"
        ></el-pagination>
      </div>
    </div>
    <!-- 筛选表格展示项 -->
    <el-dialog
      destroy-on-close
      title="统计筛选"
      :visible.sync="filterDialogVisible"
    >
      <el-form class="mwow-form">
        <el-form-item>
          <el-row>
            <el-col :span="6" v-for="item in columnFilterCopy" :key="item.key">
              <div style="text-align: left">
                <el-checkbox v-model="item.active" :disabled="item.readonly">{{
                  item.label
                }}</el-checkbox>
              </div>
            </el-col>
          </el-row>
          <div style="text-align: center; margin-top: 24px">
            <div
              class="mwow-button-filled"
              style="margin-right: 12px"
              @click="handleFilterDialogCancel"
            >
              取消
            </div>
            <div
              class="mwow-button-filled success"
              @click="handleFilterDialogSubmit"
              type="success"
            >
              确定
            </div>
          </div>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import {
  getStudentDataActivationDetailApi,
  getActivationDataInDayApi,
  getStudentActivationTotalApi,
} from "@/api/statistics";
import { dateFormat } from "@/utils/timeFormat";
import commonSearchFormWrapper from "@/components/commonSearchFormWrapper.vue";
import { searchStudent } from "@/api/globalSearch";
import json2csv from "json2csv";
import * as echarts from "echarts";
import eventBus from "@/utils/bus";
export default {
  components: {
    commonSearchFormWrapper,
  },
  props: ["date-range"],
  data() {
    return {
      topShowingValue: ["", ""],
      activationTotal: {
        total_score: "",
        deviation_roll_call_score: "",
        deviation_renew_score: "",
        deviation_homework_score: "",
        deviation_app_day_active_score: "",
        average_roll_call_score: "",
        average_renew_score: "",
        average_homework_score: "",
        average_app_day_active_score: "",
      },
      dateRangeType: 0,
      // 数据明细
      searchInfo: {
        start_date: "",
        end_date: "",
        transform_date_1: "",
        transform_date_2: "",
        student_id: "",
        student_status: "all",
        roll_call_consume_count_1: "",
        roll_call_consume_count_2: "",
        sort_field: "",
        sort_type: "",
      },
      tableData: [],
      showingData: [],
      searchStudentList: [],
      columnFilter: [
        {
          key: "student_name",
          label: "学员名称",
          active: true,
          sort: false,
          readonly: true,
          tips: "",
          fixed: true,
        },
        {
          key: "student_age",
          label: "学员年龄",
          active: true,
          sort: true,
          readonly: true,
          tips: "",
          fixed: true,
        },
        {
          key: "student_status",
          label: "学员类型",
          active: true,
          sort: false,
          readonly: true,
          tips: "",
          fixed: true,
        },
        {
          key: "transform_time",
          label: "首次入学时间",
          active: true,
          sort: true,
          readonly: false,
          tips: "",
        },
        {
          key: "total_score",
          label: "综合活跃度",
          active: true,
          sort: true,
          readonly: false,
          tips: "综合活跃度=耗课活跃度+续费活跃度+作业活跃度+APP使用活跃度",
        },
        {
          key: "roll_call_consume_score",
          label: "耗课活跃度",
          active: true,
          sort: true,
          readonly: false,
          tips: "学员耗课活跃度=学员耗课的课次数量*25",
        },
        {
          key: "roll_call_consume_count",
          label: "已耗课次数",
          active: true,
          sort: true,
          readonly: false,
          tips: "学员已上课的课次数",
        },
        {
          key: "roll_call_consume_amount",
          label: "已耗课金额",
          active: true,
          sort: true,
          readonly: false,
          tips: "学员上课已消耗的课时金额",
        },
        {
          key: "renew_score",
          label: "续费活跃度",
          active: true,
          sort: true,
          readonly: false,
          tips: "学员续费活跃度=学员续费的金额/200",
        },
        {
          key: "renew_count",
          label: "已续费次数",
          active: true,
          sort: true,
          readonly: false,
          tips: "续费订单数量（除了学员首次购课订单数，其它购课订单均为续费订单数）",
        },
        {
          key: "renew_amount",
          label: "已续费金额",
          active: true,
          sort: true,
          readonly: false,
          tips: "续费订单金额（除了学员首次购课订单金额，其它购课订单金额均为续费订单金额）",
        },
        {
          key: "homework_score",
          label: "作业活跃度",
          active: true,
          sort: true,
          readonly: false,
          tips: "学员作业活跃度=学员提交作业数*3",
        },
        {
          key: "homework_count",
          label: "老师发布作业数",
          active: true,
          sort: true,
          readonly: false,
          tips: "老师已发布作业的人次数",
        },
        {
          key: "homework_submit_count",
          label: "已提交作业数",
          active: true,
          sort: true,
          readonly: false,
          tips: "学员已提交作业数",
        },
        {
          key: "homework_corrected_count",
          label: "已批改作业数",
          active: true,
          sort: true,
          readonly: false,
          tips: "老师已批改学员提交的作业数",
        },
        {
          key: "app_day_active_score",
          label: "APP使用活跃度",
          active: true,
          sort: true,
          readonly: false,
          tips: "APP使用活跃度=学员使用APP天数",
        },
        {
          key: "app_day_active_count",
          label: "APP登录天数",
          active: true,
          sort: true,
          readonly: false,
          tips: "学员登录音乐窝APP应用的天数",
        },
        {
          key: "app_launch_count",
          label: "APP登录次数",
          active: true,
          sort: true,
          readonly: false,
          tips: "学员登录音乐窝APP应用的次数",
        },
      ],
      columnFilterCopy: [],
      filterDialogVisible: false,
      page: 1,
      pageSize: 10,
      pageSizeArray: [5, 10, 30, 50, 100],
      total: 0,
      // 图表相关
      currentDataKey: "综合活跃度",
      chartTableData: [],
      chartVisible: 1,
      chartStep: 3,
      myChart: null,
    };
  },
  computed: {
    activeColumn() {
      return this.columnFilter.filter((item) => {
        return item.active;
      });
    },
  },
  mounted() {
    let filterCache = localStorage.getItem(
      "ts-statistics-student-data-filter-params"
    );
    if (filterCache) {
      let json = JSON.parse(filterCache);
      json.filter.map((item) => {
        if (!item.active) {
          let idx = this.columnFilter.findIndex((it) => {
            return it.key === item.key;
          });
          if (idx >= 0) {
            this.columnFilter[idx].active = false;
          }
        }
      });
    }
    this.columnFilterCopy = JSON.parse(JSON.stringify(this.columnFilter));
    this.handleSearchStudent("");
    eventBus.$on("student-statistics-show-activation", () => {
      setTimeout(() => {
        this.myChart.resize();
      }, 1);
    });
    // 顶部时间组件change
    eventBus.$on("student-statistics-change-date-range-type", (type) => {
      this.dateRangeType = type;
      switch (type) {
        case 1:
          this.chartStep = 3;
          break;
        case 2:
          this.chartStep = 2;
          break;
        case 3:
          this.chartStep = 1;
          break;
      }
    });
    // 从耗课分布跳进来，先触发子级再触发父级
    eventBus.$on("student-statistics-cost-navigate-to-activation", (data) => {
      this.chartVisible = 2;
      this.searchInfo.roll_call_consume_count_1 = data.cost[0];
      if (data.cost[1] === undefined) {
        // 没传，最大值为无限
        this.searchInfo.roll_call_consume_count_2 = "";
      } else {
        this.searchInfo.roll_call_consume_count_2 = data.cost[1];
      }
    });
  },
  watch: {
    dateRange() {
      this.getTableList();
      this.getChartData();
      this.getActivationTotal();
    },
  },
  methods: {
    getActivationTotal() {
      if (!this.dateRange || this.dateRange.length !== 2) {
        return false;
      }
      getStudentActivationTotalApi({
        start_date: this.dateRange[0],
        end_date: this.dateRange[1],
      }).then((res) => {
        this.activationTotal = res.data;
        this.setTopShowingValue();
      });
    },
    handleSearchStudent(v) {
      searchStudent({
        page: 1,
        page_size: 50,
        key_word: v || "",
      }).then((res) => {
        if (res.error_code === 0) {
          this.searchStudentList = res.data.list;
        }
      });
    },
    resetSearch() {
      this.searchInfo = {
        start_date: "",
        end_date: "",
        transform_date_1: "",
        transform_date_2: "",
        student_id: "",
        student_status: "all",
        roll_call_consume_count_1: "",
        roll_call_consume_count_2: "",
      };
      this.getTableList();
    },
    handleSearch() {
      this.getTableList();
    },
    pageSplit(data) {
      this.page = data.page;
      this.pageSize = data.page_size;
      this.showingData = this.tableData.slice(
        (data.page - 1) * data.page_size,
        data.page * data.page_size
      );
    },
    handlePagerChange(e) {
      this.pageSplit({
        page: e,
        page_size: this.pageSize,
      });
    },
    handlePagerSizeChange(e) {
      this.pageSplit({
        page: this.page,
        page_size: e,
      });
    },
    solveSearchParams() {
      let option = {};
      if (
        this.searchInfo.transform_date &&
        this.searchInfo.transform_date.length === 2
      ) {
        option.transform_date_1 = this.searchInfo.transform_date[0];
        option.transform_date_2 = this.searchInfo.transform_date[1];
      }
      if (this.searchInfo.student_id !== "") {
        option.student_id = this.searchInfo.student_id;
      }
      if (this.searchInfo.student_status !== "all") {
        option.student_status = this.searchInfo.student_status;
      }
      if (this.searchInfo.roll_call_consume_count_1 !== "") {
        option.roll_call_consume_count_1 =
          this.searchInfo.roll_call_consume_count_1;
      }
      if (this.searchInfo.roll_call_consume_count_2 !== "") {
        option.roll_call_consume_count_2 =
          this.searchInfo.roll_call_consume_count_2;
      }
      return option;
    },
    handleExport() {
      try {
        let kv = {};
        let fields = [];
        this.columnFilter.map((item) => {
          if (item.active) {
            kv[item.key] = item.label;
            fields.push(item.key);
          }
        });
        const result = json2csv.parse([kv, ...this.tableData], {
          fields: fields,
          header: false,
        });
        //非IE浏览器
        const csvContent = "data:text/csv;charset=utf-8,\uFEFF" + result;
        //使用a标签的download属性实现下载功能
        const link = document.createElement("a");
        link.href = encodeURI(csvContent);
        link.download = `门店学员数据-活跃明细${this.dateRange[0]}~${this.dateRange[1]}.csv`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (err) {
        this.$message({
          type: "error",
          message: err.toString(),
        });
      }
    },
    getTableList() {
      if (!this.dateRange || this.dateRange.length !== 2) {
        return false;
      }
      const option = this.solveSearchParams();
      option.start_date = this.dateRange[0];
      option.end_date = this.dateRange[1];
      getStudentDataActivationDetailApi(option).then((res) => {
        res.data.list = res.data.list || [];
        res.data.list.map((item) => {
          item.student_name = item.student.name;
          item.student_age = item.student.age;
          item.student_status = "-";
          if (item.student.status === 1) {
            item.student_status = "意向学员";
          }
          if (item.student.status === 2) {
            item.student_status = "在读学员";
          }
          if (item.student.status === 3) {
            item.student_status = "历史学员";
          }
          if (item.student && item.student.transform_time) {
            item.transform_time = dateFormat(
              "YYYY-mm-dd",
              item.student.transform_time * 1000
            );
          } else {
            item.create_time = "-";
          }
          if (item.create_time) {
            item.create_time = dateFormat(
              "YYYY-mm-dd",
              item.create_time * 1000
            );
          } else {
            item.create_time = "-";
          }
        });
        this.tableData = res.data.list;
        this.page = 1;
        this.total = res.data.list.length;
        this.clickStort();
      });
    },
    toStudentDetail(row) {
      this.$router.push({
        name: "studyDetails",
        query: {
          id: row.student.student_id,
          tab: "activation",
          from: "student_statistics_activation",
        },
      });
    },
    showFilterDialog() {
      this.columnFilter.map((item, index) => {
        this.columnFilterCopy[index]
          ? (this.columnFilterCopy[index].active = item.active)
          : "";
      });
      this.filterDialogVisible = true;
    },
    handleFilterDialogCancel() {
      this.filterDialogVisible = false;
    },
    handleFilterDialogSubmit() {
      let activeList = this.columnFilterCopy.filter((item) => {
        return item.active;
      });
      if (activeList.length === 0) {
        this.$message({
          message: "请选择列表数据",
          type: "warning",
        });
        return false;
      }
      this.columnFilterCopy.map((item, index) => {
        this.columnFilter[index].active = item.active;
      });
      this.filterDialogVisible = false;
      this.$nextTick(() => {
        let tableEl = this.$refs["main-table"];
        tableEl.doLayout();
      });
      // 保存参数
      localStorage.setItem(
        "ts-statistics-student-data-filter-params",
        JSON.stringify({
          filter: this.columnFilter,
        })
      );
    },
    clickStort(e) {
      let prop = "";
      let order = "";
      if (e) {
        prop = e.prop;
        order = e.order;
        this.searchInfo.sort_field = e.prop;
        this.searchInfo.sort_type = e.order;
      } else {
        prop = this.searchInfo.sort_field;
        order = this.searchInfo.sort_type;
      }
      this.tableData.sort((a, b) => {
        if (order === "descending") {
          if (prop === "transform_time") {
            return new Date(b[prop]).getTime() - new Date(a[prop]).getTime();
          } else {
            return Number(b[prop]) - Number(a[prop]);
          }
        } else {
          if (prop === "transform_time") {
            return new Date(a[prop]).getTime() - new Date(b[prop]).getTime();
          } else {
            return Number(a[prop]) - Number(b[prop]);
          }
        }
      });
      this.pageSplit({
        page: this.page,
        page_size: this.pageSize,
      });
    },
    getChartData() {
      if (!this.dateRange || this.dateRange.length !== 2) {
        return false;
      }
      getActivationDataInDayApi({
        start_date: this.dateRange[0],
        end_date: this.dateRange[1],
      }).then((res) => {
        this.chartTableData = res.data.list.reverse();
        this.chartRender();
      });
    },
    chartRender() {
      let data = this.chartTableData;
      let total_score_Y = [];
      let roll_call_consume_score_Y = [];
      let renew_score_Y = [];
      let homework_score_Y = [];
      let app_day_active_score_Y = [];
      let date_X = [];
      if (this.chartStep === 1) {
        // 按月
        let total_score_total = 0;
        let roll_call_consume_score_total = 0;
        let renew_score_total = 0;
        let homework_score_total = 0;
        let app_day_active_score_total = 0;
        data.map((date, index) => {
          if (index === 0) {
            date_X.push(date.date.slice(0, 7));
          } else {
            if (new Date(date.date).getDate() === 1) {
              date_X.push(date.date.slice(0, 7));
            }
          }
          total_score_total = total_score_total + date.total_score;
          roll_call_consume_score_total =
            roll_call_consume_score_total + date.roll_call_consume_score;
          renew_score_total = renew_score_total + date.renew_score;
          homework_score_total = homework_score_total + date.homework_score;
          app_day_active_score_total =
            app_day_active_score_total + date.app_day_active_score;
          if (
            index === data.length - 1 ||
            new Date(data[index + 1].date).getDate() === 1
          ) {
            // 结算累计
            total_score_Y.push(total_score_total);
            total_score_total = 0;
            roll_call_consume_score_Y.push(roll_call_consume_score_total);
            roll_call_consume_score_total = 0;
            renew_score_Y.push(renew_score_total);
            renew_score_total = 0;
            homework_score_Y.push(homework_score_total);
            homework_score_total = 0;
            app_day_active_score_Y.push(app_day_active_score_total);
            app_day_active_score_total = 0;
          }
        });
      }
      if (this.chartStep === 2) {
        // 按周
        let total_score_total = 0;
        let roll_call_consume_score_total = 0;
        let renew_score_total = 0;
        let homework_score_total = 0;
        let app_day_active_score_total = 0;
        data.map((date, index) => {
          if (index === 0) {
            date_X.push(date.date);
          } else {
            if (new Date(date.date).getDay() === 1) {
              date_X.push(date.date);
            }
          }
          total_score_total = total_score_total + date.total_score;
          roll_call_consume_score_total =
            roll_call_consume_score_total + date.roll_call_consume_score;
          renew_score_total = renew_score_total + date.renew_score;
          homework_score_total = homework_score_total + date.homework_score;
          app_day_active_score_total =
            app_day_active_score_total + date.app_day_active_score;
          if (
            index === data.length - 1 ||
            new Date(data[index + 1].date).getDay() === 1
          ) {
            // 结算累计
            total_score_Y.push(total_score_total);
            total_score_total = 0;
            roll_call_consume_score_Y.push(roll_call_consume_score_total);
            roll_call_consume_score_total = 0;
            renew_score_Y.push(renew_score_total);
            renew_score_total = 0;
            homework_score_Y.push(homework_score_total);
            homework_score_total = 0;
            app_day_active_score_Y.push(app_day_active_score_total);
            app_day_active_score_total = 0;
          }
        });
      }
      if (this.chartStep === 3) {
        // 按日
        data.map((date) => {
          total_score_Y.push(date.total_score);
          roll_call_consume_score_Y.push(date.roll_call_consume_score);
          renew_score_Y.push(date.renew_score);
          homework_score_Y.push(date.homework_score);
          app_day_active_score_Y.push(date.app_day_active_score);
          date_X.push(date.date);
        });
      }
      let chartDom = document.getElementById("activation-echart-wrap");
      this.myChart = echarts.init(chartDom);
      let option = {
        tooltip: {
          trigger: "axis",
        },
        legend: {
          bottom: 0,
          data: [
            "综合活跃度",
            "耗课活跃度",
            "续费活跃度",
            "作业活跃度",
            "APP使用活跃度",
          ],
          selected: {
            综合活跃度: this.currentDataKey === "综合活跃度",
            耗课活跃度: this.currentDataKey === "耗课活跃度",
            续费活跃度: this.currentDataKey === "续费活跃度",
            作业活跃度: this.currentDataKey === "作业活跃度",
            APP使用活跃度: this.currentDataKey === "APP使用活跃度",
          },
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "50px",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: date_X,
        },
        yAxis: {
          type: "value",
        },
        series: [
          {
            name: "综合活跃度",
            type: "line",
            data: total_score_Y.map((n) => {
              return Number(n).toFixed(2);
            }),
          },
          {
            name: "耗课活跃度",
            type: "line",
            data: roll_call_consume_score_Y.map((n) => {
              return Number(n).toFixed(2);
            }),
          },
          {
            name: "续费活跃度",
            type: "line",
            data: renew_score_Y.map((n) => {
              return Number(n).toFixed(2);
            }),
          },
          {
            name: "作业活跃度",
            type: "line",
            data: homework_score_Y.map((n) => {
              return Number(n).toFixed(2);
            }),
          },
          {
            name: "APP使用活跃度",
            type: "line",
            data: app_day_active_score_Y.map((n) => {
              return Number(n).toFixed(2);
            }),
          },
        ],
      };
      option && this.myChart.setOption(option);
      this.myChart.on("legendselectchanged", (params) => {
        let dic = {};
        for (let key in params.selected) {
          dic[key] = false;
        }
        option.legend.selected = dic;
        option.legend.selected[params.name] = true;
        this.currentDataKey = params.name;
        this.myChart.setOption(option);
        this.setTopShowingValue();
      });
    },
    setTopShowingValue() {
      let name = this.currentDataKey || "综合活跃度";
      if (name === "综合活跃度") {
        this.topShowingValue = [
          "综合活跃度：" + this.activationTotal.total_score,
          "",
        ];
      }
      if (name === "耗课活跃度") {
        this.topShowingValue = [
          `耗课活跃度平均值:${this.activationTotal.average_roll_call_score}`,
          `平均差:${this.activationTotal.deviation_roll_call_score}`,
        ];
      }
      if (name === "续费活跃度") {
        this.topShowingValue = [
          `续费活跃度平均值:${this.activationTotal.average_renew_score}`,
          `平均差:${this.activationTotal.deviation_renew_score}`,
        ];
      }
      if (name === "作业活跃度") {
        this.topShowingValue = [
          `作业活跃度平均值:${this.activationTotal.average_homework_score}`,
          `平均差:${this.activationTotal.deviation_homework_score}`,
        ];
      }
      if (name === "APP使用活跃度") {
        this.topShowingValue = [
          `APP活跃度平均值:${this.activationTotal.average_app_day_active_score}`,
          `平均差:${this.activationTotal.deviation_app_day_active_score}`,
        ];
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.activation-container {
  position: relative;
  .export-button {
    position: absolute;
    top: -77px;
    right: 8px;
    z-index: 100;
  }
  #activation-echart-wrap {
    height: 360px;
    width: 100%;
  }
  .input-range-wrap {
    display: flex;
    position: relative;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    line-height: 30px;
    height: 30px !important;
    position: relative;
    /deep/.el-input__inner {
      border: none !important;
    }
    span {
      margin: 0 10px 0 0;
    }
    .el-input {
      width: auto;
      text-align: center;
    }
  }
}
.showing-data {
  font-size: 14px;
  color: #5c5d5e;
  margin-left: 24px;
}
.filter-button {
  display: flex;
  cursor: pointer;
  align-items: center;
  .icon {
    width: 22px;
    height: 22px;
    margin-right: 6px;
  }
  p {
    color: #333;
    font-size: 14px;
    line-height: 16px;
    &.small {
      font-size: 12px;
      color: #999;
    }
  }
}
</style>
